import React, { createContext, useContext, FC } from 'react';

import { useSemDurationRange } from 'clientState/providers/ParsedSearchResponseProvider';

export type DurationRange = {
  minDays: number;
  maxDays: number;
};

type SemDurationContextType = {
  initialRange: DurationRange | null;
  durationRangeSelected: DurationRange | null;
  isSemDurationFilterApplied: boolean;
  applyDurationRange: (range: DurationRange) => void;
  resetSemDurationFilter: () => void;
};

export const SemDurationFilterContext = createContext<SemDurationContextType>(
  {} as SemDurationContextType
);

export const useSemDurationFilter = (): SemDurationContextType =>
  useContext(SemDurationFilterContext);

const SemDurationFilterProvider: FC = ({ children }) => {
  const initialRange = useSemDurationRange();
  const [durationRangeSelected, setDurationRangeSelected] =
    React.useState<DurationRange | null>(null);
  const [isSemDurationFilterApplied, setSemDurationFilterApplied] =
    React.useState<boolean>(false);

  const applyDurationRange = (range: DurationRange): void => {
    if (!initialRange) return;
    setDurationRangeSelected(range);
    setSemDurationFilterApplied(
      initialRange.minDays < range.minDays ||
        initialRange.maxDays > range.maxDays
    );
  };

  const resetSemDurationFilter = (): void => {
    setDurationRangeSelected(initialRange);
    setSemDurationFilterApplied(false);
  };

  const value = {
    initialRange,
    isSemDurationFilterApplied,
    durationRangeSelected: durationRangeSelected
      ? durationRangeSelected
      : initialRange,
    applyDurationRange,
    resetSemDurationFilter,
  };

  return (
    <SemDurationFilterContext.Provider value={value}>
      {children}
    </SemDurationFilterContext.Provider>
  );
};

export default SemDurationFilterProvider;
